import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Router } from '@angular/router';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { RedirectToPhp } from './redirect-to-php.service';

/**
 * Use this guard on routes where the webapp version of the page hasn't
 * been implemented yet
 */
export const RedirectToPhpGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const redirectToPhp = inject(RedirectToPhp);
  const router = inject(Router);
  const uiConfig = inject(UI_CONFIG);

  if (!!route.data?.removeThemeFromUrl && uiConfig.theme) {
    const currentNavigation = router.getCurrentNavigation();
    if (currentNavigation) {
      currentNavigation.extras.skipLocationChange = false;
    }

    const url =
      state.url.startsWith(`/${uiConfig.theme}/`) ||
      state.url.startsWith(`${uiConfig.theme}/`)
        ? state.url.slice(uiConfig.theme.length + 1)
        : state.url;

    return redirectToPhp.doRedirect(url);
  }

  return redirectToPhp.doRedirect(state.url);
};
